import {handleActions} from 'redux-actions'
import * as ActionTypes from "./actionTypes";
import {filterMapByKeys, arrayToMap, filterMapByKey} from "../atUtils";

function addEntitiesToMap(map, entities) {
    const newMap = {
        ...map
    }
    entities.forEach((entity) => {
        newMap[entity.id] = entity
    })
    return newMap
}

const createEntitiesReducer = ({
    USERS = [],
    USER_GROUPS = [],
    TIME_ZONE_GROUPS = [],
    TASKS = [],
    PROJECTS = [],
    CUSTOMERS = [],
    WORKFLOW_STATUSES = [],
    TYPES_OF_WORK = [],
}) => {
    const initialState = {
        users: arrayToMap(USERS),
        tasks: arrayToMap(TASKS),
        projects: arrayToMap(PROJECTS),
        customers: arrayToMap(CUSTOMERS),
        typesOfWork: arrayToMap(TYPES_OF_WORK),
        workflowStatuses: arrayToMap(WORKFLOW_STATUSES),
        userGroups: arrayToMap(USER_GROUPS),
        timeZoneGroups: arrayToMap(TIME_ZONE_GROUPS),
    }

    return handleActions({
        [ActionTypes.USERS_ADD]: (state, {payload: users}) => ({...state, users: addEntitiesToMap(state.users, users)}),
        [ActionTypes.USERS_REMOVE]: (state, {payload: ids}) => ({...state, users: filterMapByKeys(state.users, ids)}),
        [ActionTypes.USER_GROUPS_ADD]: (state, {payload: userGroups}) => ({
            ...state,
            userGroups: addEntitiesToMap(state.userGroups, userGroups)
        }),
        [ActionTypes.USER_GROUPS_SET]: (state, {payload: userGroups}) => ({
            ...state,
            userGroups,
        }),
        [ActionTypes.USER_GROUPS_REMOVE]: (state, {payload: ids}) => ({
            ...state,
            userGroups: filterMapByKeys(state.userGroups, ids)
        }),
        [ActionTypes.TIME_ZONE_GROUPS_ADD]: (state, {payload: timeZoneGroups}) => ({
            ...state,
            timeZoneGroups: addEntitiesToMap(state.timeZoneGroups, timeZoneGroups)
        }),
        [ActionTypes.TIME_ZONE_GROUPS_SET]: (state, {payload: timeZoneGroups}) => ({
            ...state,
            timeZoneGroups,
        }),
        [ActionTypes.TIME_ZONE_GROUPS_REMOVE]: (state, {payload: ids}) => ({
            ...state,
            timeZoneGroups: filterMapByKeys(state.timeZoneGroups, ids)
        }),
        [ActionTypes.TASKS_ADD]: (state, {payload: tasks}) => ({...state, tasks: addEntitiesToMap(state.tasks, tasks)}),
        [ActionTypes.TASKS_REMOVE]: (state, {payload: ids}) => ({...state, tasks: filterMapByKeys(state.tasks, ids)}),
        [ActionTypes.TASKS_CLEAR]: (state) => ({...state, tasks: []}),
        [ActionTypes.PROJECTS_ADD]: (state, {payload: projects}) => ({...state, projects: addEntitiesToMap(state.projects, projects)}),
        [ActionTypes.PROJECTS_REMOVE]: (state, {payload: ids}) => ({...state, projects: filterMapByKeys(state.projects, ids)}),
        [ActionTypes.CUSTOMERS_ADD]: (state, {payload: customers}) => ({...state, customers: addEntitiesToMap(state.customers, customers)}),
        [ActionTypes.CUSTOMERS_REMOVE]: (state, {payload: ids}) => ({...state, customers: filterMapByKeys(state.customers, ids)}),
        [ActionTypes.WORKFLOW_STATUSES_ADD]: (state, {payload: workflowStatuses}) => ({
            ...state,
            workflowStatuses: addEntitiesToMap(state.workflowStatuses, workflowStatuses)
        }),
        [ActionTypes.WORKFLOW_STATUSES_SET]: (state, {payload: workflowStatuses}) => ({
            ...state,
            workflowStatuses,
        }),
        [ActionTypes.WORKFLOW_STATUSES_REMOVE]: (state, {payload: ids}) => ({...state, workflowStatuses: filterMapByKeys(state.workflowStatuses, ids)}),
        [ActionTypes.TYPES_OF_WORK_SET]: (state, {payload: typesOfWork}) => ({...state, typesOfWork: typesOfWork})
    }, initialState)
}

export default createEntitiesReducer



// WEBPACK FOOTER //
// ./web/js/entities/reducer.js